import { render } from "./Reservation.vue?vue&type=template&id=344374f1"
import script from "./Reservation.vue?vue&type=script&lang=js"
export * from "./Reservation.vue?vue&type=script&lang=js"

import "./Reservation.vue?vue&type=style&index=0&id=344374f1&lang=css"
import "primevue/resources/primevue.min.css?vue&type=style&index=1&lang=css&external"
import "primeicons/primeicons.css?vue&type=style&index=2&lang=css&external"
import "primevue/resources/themes/saga-blue/theme.css?vue&type=style&index=3&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__